import { AgentTestOperation } from '@elementary/common-ui/types';

export const BREADCRUMB_LABELS: Record<AgentTestOperation, string> = {
  update: 'Changes Preview',
  create: 'Creation Preview',
  delete: 'Deletion Preview',
};

export const STORAGE_KEY = 'custom_sql_agent_config_preview_table';
